import addPubs from './components/addPubs.vue';
import showPubs from './components/showPubs.vue';
// import home from './components/home.vue';
import students from './components/students.vue';
import projects from './components/projects.vue';
import Hobies from './components/hobies.vue';
import Media from './components/media.vue';

export default [
  {path:'/', component:Media}, // Root pathes
  {path:'/showp', component:showPubs},   // Next Pathes
  {path:'/addp', component:addPubs},   // Next Pathes
  {path:'/students', component:students},   // Next Pathes
  {path:'/projects', component:projects},   // Next Pathes
  {path:'/hobies', component:Hobies}   // Next Pathes
]